// This component is deprecated - "Add People" feature now shows "Coming Soon" modal
// File kept for backwards compatibility only

export default function AddPeopleModal() {
  return null;
}
